module.exports = __webpack_public_path__ + "static/img/bg.4886f64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010224/bg.png
// module id = /G0s
// module chunks = 10